export const STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia",
  "Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland",
  "Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire",
  "New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania",
  "Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington",
  "West Virginia","Wisconsin","Wyoming"
];

export const PRIORITY_STATES = ["California", "Texas", "Florida", "New York"];

export const VEHICLE_TYPES = ["Car", "Truck", "Motorcycle", "Trailer", "RV", "Boat", "Other"];

export const PAYMENT_METHODS = ["Cash", "Cashier's check", "Bank transfer", "Certified check", "Money order", "Other"];

export const ODOMETER_STATUSES = ["Actual mileage", "Not actual mileage", "Exceeds mechanical limits", "Odometer discrepancy / unknown"];

export const SALE_TYPES = ["As-is, no warranty", "With limited written warranty", "Gift", "Trade", "Other"];

export const PHOTO_CATEGORIES = [
  { value: "exterior", label: "Exterior" },
  { value: "interior", label: "Interior" },
  { value: "odometer", label: "Odometer" },
  { value: "vin_plate", label: "VIN plate" },
  { value: "title", label: "Title" },
  { value: "damage", label: "Damage" },
  { value: "payment_receipt", label: "Payment receipt" },
  { value: "other", label: "Other" },
];

export const INCLUDED_ITEM_OPTIONS = ["Keys", "Title", "Registration", "Manuals", "Service records", "Spare tire", "Charging cable", "Accessories", "Other"];

export const DEFAULT_CLAUSES = [
  { key: "as_is", label: "Vehicle is sold as-is", selected: true },
  { key: "accept_condition", label: "Buyer accepts current condition", selected: true },
  { key: "no_verbal", label: "No verbal promises outside this agreement", selected: true },
  { key: "disclose_defects", label: "Seller discloses known defects", selected: true },
  { key: "buyer_taxes", label: "Buyer is responsible for registration, taxes and fees after sale", selected: true },
  { key: "seller_title", label: "Seller is responsible for providing signed title", selected: true },
  { key: "buyer_insurance", label: "Buyer is responsible for insurance after delivery", selected: true },
  { key: "delivered_keys", label: "Vehicle is delivered with keys", selected: true },
  { key: "delivered_title", label: "Vehicle is delivered with title", selected: true },
  { key: "delivered_manuals", label: "Vehicle is delivered with manuals", selected: false },
  { key: "delivered_records", label: "Vehicle is delivered with service records, if available", selected: false },
  { key: "no_ownership_retained", label: "Seller retains no ownership after payment and delivery", selected: true },
  { key: "buyer_risk", label: "Buyer assumes risk after delivery", selected: true },
  { key: "dmv_cooperate", label: "Parties agree to cooperate with DMV transfer requirements", selected: true },
];

export const STATE_SLUGS = {
  California: "california-car-bill-of-sale",
  Texas: "texas-car-bill-of-sale",
  Florida: "florida-car-bill-of-sale",
  "New York": "new-york-car-bill-of-sale",
};
